webpackJsonp([35783957827783],{

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(67);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(65);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _NetlifyForm = __webpack_require__(68);
	
	var _NetlifyForm2 = _interopRequireDefault(_NetlifyForm);
	
	var _FooterCC = __webpack_require__(78);
	
	var _FooterCC2 = _interopRequireDefault(_FooterCC);
	
	var _reactIframe = __webpack_require__(66);
	
	var _reactIframe2 = _interopRequireDefault(_reactIframe);
	
	var _Split = __webpack_require__(44);
	
	var _Split2 = _interopRequireDefault(_Split);
	
	var _App = __webpack_require__(36);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Sidebar = __webpack_require__(59);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _LoginForm = __webpack_require__(55);
	
	var _LoginForm2 = _interopRequireDefault(_LoginForm);
	
	var _Article = __webpack_require__(37);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _Section = __webpack_require__(42);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Heading = __webpack_require__(16);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Paragraph = __webpack_require__(24);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	var _Footer = __webpack_require__(38);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Grommet = __webpack_require__(63);
	
	var _Grommet2 = _interopRequireDefault(_Grommet);
	
	var _Header = __webpack_require__(53);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Title = __webpack_require__(61);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Menu = __webpack_require__(41);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Anchor = __webpack_require__(27);
	
	var _Anchor2 = _interopRequireDefault(_Anchor);
	
	var _Box = __webpack_require__(8);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Quote = __webpack_require__(57);
	
	var _Quote2 = _interopRequireDefault(_Quote);
	
	var _Card = __webpack_require__(51);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Columns = __webpack_require__(52);
	
	var _Columns2 = _interopRequireDefault(_Columns);
	
	var _Image = __webpack_require__(40);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Headline = __webpack_require__(39);
	
	var _Headline2 = _interopRequireDefault(_Headline);
	
	var _Button = __webpack_require__(14);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SocialFacebook = __webpack_require__(45);
	
	var _SocialFacebook2 = _interopRequireDefault(_SocialFacebook);
	
	var _LinkNext = __webpack_require__(28);
	
	var _LinkNext2 = _interopRequireDefault(_LinkNext);
	
	var _Hero = __webpack_require__(54);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Form = __webpack_require__(30);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormField = __webpack_require__(31);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _TextInput = __webpack_require__(60);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _NumberInput = __webpack_require__(56);
	
	var _NumberInput2 = _interopRequireDefault(_NumberInput);
	
	var _SVGIcon = __webpack_require__(58);
	
	var _SVGIcon2 = _interopRequireDefault(_SVGIcon);
	
	var _Toast = __webpack_require__(62);
	
	var _Toast2 = _interopRequireDefault(_Toast);
	
	var _SocialShare = __webpack_require__(43);
	
	var _SocialShare2 = _interopRequireDefault(_SocialShare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Homepage = function (_React$PureComponent) {
	  _inherits(Homepage, _React$PureComponent);
	
	  function Homepage() {
	    _classCallCheck(this, Homepage);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Homepage.prototype.render = function render() {
	    return _react2.default.createElement(
	      _Article2.default,
	      { scrollStep: true, id: 'grad' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Clean Clothes | Volunteer Laundry Service For The Homeless'
	        )
	      ),
	      _react2.default.createElement(
	        _Article2.default,
	        { texture: './hero.png', className: 'hero', pad: { vertical: 'small' }, margin: { top: 'large' } },
	        _react2.default.createElement(
	          _Section2.default,
	          { justify: 'center', align: 'center', textAlign: 'center', pad: { vertical: 'xlarge', horizontal: 'small' } },
	          _react2.default.createElement(
	            _Heading2.default,
	            { tag: 'h1', align: 'center' },
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Clean Clothes for Dignity'
	            )
	          ),
	          _react2.default.createElement(
	            _Heading2.default,
	            { tag: 'h3', align: 'center' },
	            'Volunteer Laundry Service For The Homeless'
	          ),
	          _react2.default.createElement(
	            _Paragraph2.default,
	            { className: 'small-text' },
	            'Clean Clothes is a program set up to unite two communities. It provides the means for the homeless to do their laundry. Volunteers set up in local laundromats with quarters and laundry soap and the homeless bring their clothing to be washed.'
	          ),
	          _react2.default.createElement(
	            _Section2.default,
	            { pad: { vertical: 'large' } },
	            _react2.default.createElement(
	              _Menu2.default,
	              { direction: 'row', size: 'small', justify: 'between', responsive: false, pad: { vertical: 'large' } },
	              _react2.default.createElement(_Anchor2.default, { label: 'Customers', href: '/customers' }),
	              _react2.default.createElement(_Anchor2.default, { label: 'Volunteers', href: '/volunteers' }),
	              _react2.default.createElement(_Anchor2.default, { label: 'Sponsors', href: '#', disabled: true }),
	              _react2.default.createElement(_Anchor2.default, { label: 'Contact', href: '/contact' })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Article2.default,
	        { full: true },
	        _react2.default.createElement(
	          _Box2.default,
	          { justify: 'center', align: 'center', direction: 'row', flex: true },
	          _react2.default.createElement(
	            _Box2.default,
	            null,
	            _react2.default.createElement(_Image2.default, {
	              fit: 'contain',
	              src: './2.png' })
	          ),
	          _react2.default.createElement(
	            _Card2.default,
	            { heading: 'More than laundry',
	              textAlign: 'left',
	              link: _react2.default.createElement(_Anchor2.default, { href: '/our-story',
	                label: 'Our Story', icon: _react2.default.createElement(_LinkNext2.default, null) }) },
	            _react2.default.createElement(
	              _Paragraph2.default,
	              null,
	              'Clean Clothes for Dignity provides funds and soap for the homeless to do laundry. More than that, they restore the dignity of the homeless. Homeless people often lack clean clothing, which can make them feel ashamed and cut off from society.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Article2.default,
	        { full: true },
	        _react2.default.createElement(
	          _Box2.default,
	          { justify: 'center', align: 'center', direction: 'row', flex: true, reverse: true },
	          _react2.default.createElement(
	            _Box2.default,
	            null,
	            _react2.default.createElement(_Image2.default, {
	              fit: 'contain',
	              src: './1.png' })
	          ),
	          _react2.default.createElement(
	            _Card2.default,
	            { heading: 'A fresh start',
	              textAlign: 'left',
	              link: _react2.default.createElement(_Anchor2.default, { href: '/customers',
	                label: 'Customer Stories', icon: _react2.default.createElement(_LinkNext2.default, null) }) },
	            _react2.default.createElement(
	              _Paragraph2.default,
	              null,
	              'A clean pair of clothes is a fresh start. Clean clothes makes it possible for a homeless person to find a job, participate in society, feel like a person again, and helps remove the outward signs of homelessness that so often stigmatizes them.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Article2.default,
	        { full: true },
	        _react2.default.createElement(
	          _Box2.default,
	          { justify: 'center', align: 'center', direction: 'row', flex: true },
	          _react2.default.createElement(
	            _Box2.default,
	            null,
	            _react2.default.createElement(_Image2.default, {
	              fit: 'contain',
	              src: './3.png' })
	          ),
	          _react2.default.createElement(
	            _Card2.default,
	            { heading: 'Building a bridge',
	              textAlign: 'left',
	              link: _react2.default.createElement(_Anchor2.default, { href: '/contact',
	                label: 'Get Involved', icon: _react2.default.createElement(_LinkNext2.default, null) }) },
	            _react2.default.createElement(
	              _Paragraph2.default,
	              null,
	              'Clean Clothes for Dignity allows volunteers and members of the homeless community to share in the most basic and precious of human goods: sharing a piece of one\u2019s life with another human being.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Article2.default,
	        { texture: './sign.png', full: true },
	        _react2.default.createElement(
	          _Box2.default,
	          { pad: 'medium', textAlign: 'left', align: 'center', justify: 'center', flex: true },
	          _react2.default.createElement(
	            _Heading2.default,
	            { tag: 'h2' },
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Donate'
	            )
	          ),
	          _react2.default.createElement(
	            _Paragraph2.default,
	            { size: 'medium' },
	            'Looking for a simple, practical way to make a big difference? Clean Clothes for Asheville is looking for gifts to help sustain us for the long term. A wash, dry and supplies cost about $5 per customer. Clean Clothes requires about $250 a month to survive. Any gift is appreciated.'
	          ),
	          _react2.default.createElement(
	            _Box2.default,
	            { align: 'center' },
	            _react2.default.createElement(
	              'form',
	              { action: 'https://www.paypal.com/cgi-bin/webscr', method: 'post', target: '_top' },
	              _react2.default.createElement('input', { type: 'hidden', name: 'cmd', value: '_s-xclick' }),
	              _react2.default.createElement('input', { type: 'hidden', name: 'encrypted', value: '-----BEGIN PKCS7-----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-----END PKCS7-----\r ' }),
	              _react2.default.createElement('input', { type: 'image', src: 'https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif', name: 'submit', alt: 'PayPal - The safer, easier way to pay online!' }),
	              _react2.default.createElement('img', { alt: '', src: 'https://www.paypalobjects.com/en_US/i/scr/pixel.gif', width: '1', height: '1' })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Article2.default,
	        { texture: '/store.png', full: true },
	        _react2.default.createElement(
	          _Box2.default,
	          { justify: 'center', align: 'center', direction: 'row', flex: true,
	            backgroundColorIndex: 'dark' },
	          _react2.default.createElement(
	            _Box2.default,
	            { direction: 'row',
	              justify: 'center',
	              align: 'center',
	              flex: true },
	            _react2.default.createElement(_Box2.default, { basis: 'xsmall',
	              align: 'end',
	              pad: 'medium' }),
	            _react2.default.createElement(
	              _Box2.default,
	              { basis: 'full',
	                align: 'center',
	                justify: 'center',
	                pad: 'medium' },
	              _react2.default.createElement(
	                _Box2.default,
	                { colorIndex: 'grey-2-a' },
	                _react2.default.createElement(
	                  _Box2.default,
	                  { textAlign: 'left', pad: 'medium' },
	                  _react2.default.createElement(
	                    _Heading2.default,
	                    { tag: 'h2' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      'Support The Cause'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _Heading2.default,
	                    { tag: 'h3' },
	                    _react2.default.createElement(
	                      'i',
	                      null,
	                      'Volunteer:'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _Paragraph2.default,
	                    null,
	                    'Come Volunteer Wednesday nights 5 pm \u2013 8 pm at ',
	                    _react2.default.createElement(
	                      _Anchor2.default,
	                      { href: 'https://www.google.com/maps/place/Dutch+Girl+Coin+Laundry/@35.5610088,-82.5942075,13z/data=!4m8!1m2!2m1!1sdutch+girl+coin+laundry+asheville+nc!3m4!1s0x0:0xbe6e45b67a0b3599!8m2!3d35.5805465!4d-82.5971031' },
	                      'Dutch Girl Coin Laundry'
	                    ),
	                    ' on Haywood Rd in West Asheville.'
	                  ),
	                  _react2.default.createElement(
	                    _Box2.default,
	                    { pad: { vertical: 'medium' } },
	                    _react2.default.createElement(
	                      _Heading2.default,
	                      { tag: 'h3' },
	                      _react2.default.createElement(
	                        'i',
	                        null,
	                        'Share our story:'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _Box2.default,
	                      { direction: 'row', responsive: false },
	                      _react2.default.createElement(_SocialShare2.default, { link: 'https://cleanclothesfordignity.com',
	                        type: 'email',
	                        title: 'Check Out Clean Clothes for Dignity',
	                        text: 'Volunteer Laundry Service for the Homeless' }),
	                      _react2.default.createElement(_SocialShare2.default, { type: 'facebook',
	                        link: 'https://cleanclothesfordignity.com' }),
	                      _react2.default.createElement(_SocialShare2.default, { type: 'twitter',
	                        link: 'https://cleanclothesfordignity.com',
	                        text: 'Check Out Clean Clothes for Dignity' }),
	                      _react2.default.createElement(_SocialShare2.default, { type: 'google',
	                        link: 'https://cleanclothesfordignity.com' })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_FooterCC2.default, null)
	    );
	  };
	
	  return Homepage;
	}(_react2.default.PureComponent);
	
	exports.default = Homepage;
	module.exports = exports['default'];

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Homepage = __webpack_require__(277);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Homepage).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Homepage = __webpack_require__(278);
	
	var _Homepage2 = _interopRequireDefault(_Homepage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index() {
	    _classCallCheck(this, Index);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Index.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Homepage2.default, null)
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	exports.default = Index;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-6722a1fae711f10113ab.js